import React from "react"
import { Link } from "react-router-dom"
import RatingStars from "../../../elements/ratingStars"
import { Image } from "../../../../components/elements"
import cloudinary from "cloudinary-core"
import { CLOUDINARY_NAME } from "../../../../constants/images/cloudinary"
import OwnerEmailVerification from "./OwnerEmailVerification"
import OwnerPhoneVerification from "./OwnerPhoneVerification"
let check_icon = require('../../../theme/assets/images/check-box-brown.png')

const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME
})

const OwnerBadge = props => (
  <>
    {props.showBatch && <Image
      src={cl.url(props.bikeData.bike_owner_avatar_cloudinary_public_id, {
        gravity: "center",
        height: 100,
        width: 100,
        crop: "fill",
        format: "jpg"
      })}
      rounded
      className={"is-inline-block m"}
      size={props.isMobile ? 48 : 64}
      alt={props.bikeData.bike_owner_name + "'s Profile"}
    />} 

    {!props.isMobile && props.bikeData.bike_owner_rating > 0 ?(
        null
        ):[
          !props.isMobile && props.bikeData.bike_owner_phone_verified && props.bikeData.bike_owner_email_verified ?
            <>
               <div className="verified_check_block">
                <img src={check_icon} className="check_icon_image" alt="phone-email-verified"/>
                <p className="verification_confirmation_text"> Phone &#38; Email Verified</p>
              </div>
            </>
        : 
          props.isMobile && props.bikeData.bike_owner_phone_verified && props.bikeData.bike_owner_email_verified ?
            <div className="verified_check_block">
              <img src={check_icon} className="check_icon_image" alt="verified"/>
              <p className="verification_confirmation_text">Verified</p>
            </div>
        :
          !props.isMobile && props.bikeData.bike_owner_phone_verified ?
            <OwnerPhoneVerification />
        : 
          props.isMobile && props.bikeData.bike_owner_phone_verified ?
            <div className="verified_check_block">
              <img src={check_icon} className="check_icon_image" alt="verified"/>
              <p className="verification_confirmation_text">Verified</p>
            </div>
        : 
          !props.isMobile && props.bikeData.bike_owner_email_verified ?
            <OwnerEmailVerification />
        : 
          props.isMobile && props.bikeData.bike_owner_email_verified ?
            <div className="verified_check_block">
              <img src={check_icon} className="check_icon_image" alt="verified"/>
              <p className="verification_confirmation_text">Verified</p>
            </div>
        : 
        null
        ] 
    }
  </>
)

export default OwnerBadge